import React, { useContext } from 'react';
import { getAppEnv } from '../../../../config/env';
import { EnvironmentVariables } from '../../../types';
import { CityLocation } from '../../runtime-typechecker';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import { SET_WIDGET } from '../cabsLandingPageState';
import { cabsLandingWidgetInfo } from '../../../cabsLandingWidgetInfo';
import { CAB_FROM_AIRPORT, CAB_TO_AIRPORT } from '../../../constants/tripTypes';
import {
  MOB_CABS_OW_LANDING_PICKUP_CLICK,
  MOB_CABS_OW_LANDING_DESTINATION_CLICK,
  MOB_CABS_HR_LANDING_PICKUP_CLICK,
  MOB_CABS_AT_LANDING_CITY_CLICK,
  MOB_CABS_AT_LANDING_AIRPORT_CLICK
} from '../../../constants/omnitureConstants';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const removeCommas = (text: string) => {
  return text.replace(/,/g, '');
};

export const decorateLocation = (location: CityLocation) => {
  if (!location) return null;
  const { city, subText } = location;
  if (city && subText) {
    return (
      <div>
        <span style={{ width: '80%', display: 'block' }} className="truncate">
          <span className="blackText latoBlack font16 lineHeight22">
            {removeCommas(city)}
          </span>
          <span>&nbsp;</span>
          <span className="font12 latoRegular greyishBlackText">
            {removeCommas(subText)}
          </span>
        </span>
      </div>
    );
  }

  if (city) {
    return (
      <span className="blackText latoBlack font16 lineHeight22">{city}</span>
    );
  }

  return null;
};
const setOmniture = (id, trackTemplateEvent) => {
  switch (id) {
    case 'OW_PICKUP':
      trackTemplateEvent(MOB_CABS_OW_LANDING_PICKUP_CLICK);
      break;
    case 'OW_DROP':
      trackTemplateEvent(MOB_CABS_OW_LANDING_DESTINATION_CLICK);
      break;
    case 'AT_CITY':
      trackTemplateEvent(MOB_CABS_AT_LANDING_CITY_CLICK);
      break;

    case 'AT_AIRPORT':
      trackTemplateEvent(MOB_CABS_AT_LANDING_AIRPORT_CLICK);
      break;
    case 'RENTAL_CITY':
      trackTemplateEvent(MOB_CABS_HR_LANDING_PICKUP_CLICK);
      break;
    default:
      break;
  }
};

export const LocationInputSection = ({
  id,
  widgetNumber,
  location,
  widgetComponent,
  imageName,
  placeHolder,
  inputTitle
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);
  const { trackTemplateEvent } = cabsLandingContext;

  const setWidget = widgetNumber => {
    dispatch && dispatch({ type: SET_WIDGET, newStateValue: widgetNumber });
  };

  const { widget } = cabsLandingContext;

  return (
    <div className="fullWidth" id={id}>
      <div
        className="fullWidth cabsLandingRsw rsw"
        style={{
          backgroundColor: 'rgb(247, 247, 247)',
          border: '1px solid rgb(231, 231, 231)',
          marginTop: '10px'
        }}
      >
        <div
          className="fullWidth"
          onClick={() => {
            setWidget(widgetNumber);
            setOmniture(id, trackTemplateEvent);
          }}
        >
          <div className="makeFlex alignCenter vrtlCenter2">
            <img
              className="appendRight10"
              src={`${PUBLIC_URL}/static/public/${imageName}`}
              height={'24px'}
              width={'24px'}
              alt="logo"
            />
            <div className="fullWidth">
              {location != null ? (
                <div id="location_input">
                  <div className="latoBold lightGreyText font11">
                    {placeHolder}
                  </div>
                  <div>{decorateLocation(location)}</div>
                </div>
              ) : (
                <div
                  id="location_title"
                  style={{ color: 'rgb(155, 155, 155)' }}
                  className="latoBold font14"
                >
                  {inputTitle}
                </div>
              )}
            </div>
          </div>
        </div>
        {widget == widgetNumber && widgetComponent}
      </div>
    </div>
  );
};

export const SourceLocationInput = ({ widgetMap }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { sourceCity } = cabsLandingContext;
  return (
    <LocationInputSection
      id={'OW_PICKUP'}
      location={sourceCity}
      widgetNumber={cabsLandingWidgetInfo.OUTSTATION_PICKUP_LOCATION_WIDGET}
      widgetComponent={widgetMap.get(
        cabsLandingWidgetInfo.OUTSTATION_PICKUP_LOCATION_WIDGET
      )}
      imageName={'from.webp'}
      inputTitle={'PICK UP ADDRESS'}
      placeHolder={'FROM LOCATION'}
    />
  );
};

export const DestinationLocationInput = ({ widgetMap }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { destinationCity } = cabsLandingContext;

  return (
    <LocationInputSection
      id={'OW_DROP'}
      location={destinationCity}
      widgetNumber={cabsLandingWidgetInfo.OUTSTATION_DROP_LOCATION_WIDGET}
      widgetComponent={widgetMap.get(
        cabsLandingWidgetInfo.OUTSTATION_DROP_LOCATION_WIDGET
      )}
      imageName={'to.webp'}
      inputTitle={'DROP ADDRESS'}
      placeHolder={'TO LOCATION'}
    />
  );
};

export const AirportCityLocationInput = ({ widgetMap, widgetNumber }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { airportCity, travelFor } = cabsLandingContext;

  const inputTitle =
    travelFor === CAB_TO_AIRPORT ? 'PICK UP ADDRESS' : 'DROP ADDRESS';
  const placeHolder =
    travelFor === CAB_TO_AIRPORT ? 'FROM LOCATION' : 'TO LOCATION';
  const imgName = travelFor === CAB_TO_AIRPORT ? 'from.webp' : 'to.webp';
  return (
    <LocationInputSection
      id={'AT_CITY'}
      location={airportCity}
      widgetNumber={widgetNumber}
      widgetComponent={widgetMap.get(widgetNumber)}
      imageName={imgName}
      inputTitle={inputTitle}
      placeHolder={placeHolder}
    />
  );
};

export const AirportLocationInput = ({ widgetMap, widgetNumber }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { airport, travelFor } = cabsLandingContext;

  const inputTitle = 'AIRPORT NAME';
  const placeHolder =
    travelFor === CAB_FROM_AIRPORT ? 'FROM AIRPORT' : 'TO AIRPORT';
  const imgName = travelFor === CAB_TO_AIRPORT ? 'to.webp' : 'from.webp';

  return (
    <LocationInputSection
      id={'AT_AIRPORT'}
      location={airport}
      widgetNumber={widgetNumber}
      widgetComponent={widgetMap.get(widgetNumber)}
      imageName={imgName}
      inputTitle={inputTitle}
      placeHolder={placeHolder}
    />
  );
};

export const RentalLocationInput = ({ widgetMap }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { rentalCity } = cabsLandingContext;

  return (
    <LocationInputSection
      id={'RENTAL_CITY'}
      location={rentalCity}
      widgetNumber={cabsLandingWidgetInfo.RENTAL_PICKUP_LOCATION_WIDGET}
      widgetComponent={widgetMap.get(
        cabsLandingWidgetInfo.RENTAL_PICKUP_LOCATION_WIDGET
      )}
      imageName={'from.webp'}
      placeHolder={'FROM'}
      inputTitle={'PICK UP ADDRESS'}
    />
  );
};
